<template>
  <v-app>
    <v-tabs v-model="active" color="primary" dark slider-color="yellow">
      <v-tab :key="2" ripple> {{ $t("drivers.createConstraint.constraint") }} </v-tab>
      <v-tab-item>
        <v-container fluid>
          <v-layout align-start justify-space-around fill-height gap>
            <v-flex xs6 grow pr-4>
              <v-layout align-start justify-start column xs>
                <v-flex xs12>
                  <h1 class="headline">{{ $t("drivers.createConstraint.constraintInformation") }}</h1>
                </v-flex>
                <v-flex xs12 mt-3 grow class="full-width">
                  <v-form ref="form" v-model="form" class="xs12 full-width">
                    <v-flex xs12>
                      <v-text-field
                        outline
                        v-model="model.constraint_name"
                        :rules="[rules.required]"
                        :label="$t('drivers.createConstraint.constraintName')"
                        type="text"
                        grow
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        outline
                        v-model="model.Abbreviation"
                        :rules="[rules.required]"
                        :label="$t('drivers.createConstraint.constraintAbbreviation')"
                        type="text"
                        grow
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        outline
                        v-model="model.customer_app_message"
                        :rules="[rules.required]"
                        :label="$t('drivers.createConstraint.customerAppMessage')"
                        type="text"
                        grow
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        :label="$t('drivers.createConstraint.canDriverEdit')"
                        :items="[{text:$t('common.yes'),value:1}, {text:$t('common.no'),value:0}]"
                        v-model="model.driver_on_off"
                      ></v-select>
                    </v-flex>

                    <v-flex xs12>
                      <v-select
                        :label="$t('drivers.createConstraint.showInCustomerApp')"
                        :items="[{text:$t('common.yes'),value:1}, {text:$t('common.no'),value:0}]"
                        v-model="model.customer_on_off"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        :label="$t('drivers.createConstraint.showInCustomerDashboard')"
                        :items="[{text:$t('common.yes'),value:1}, {text:$t('common.no'),value:0}]"
                        v-model="model.dashboard_on_off"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        :label="$t('drivers.createConstraint.strikeThrough')"
                        :items="[{text:$t('common.yes'),value:1}, {text:$t('common.no'),value:0}]"
                        v-model="model.strike_through"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        :label="$t('drivers.createConstraint.constraintType')"
                        :items="[{ text: $t('drivers.createConstraint.captain'), value: 'CAPTAIN' }, { text: $t('drivers.createConstraint.car'), value: 'CAR' }]"
                        :rules="[rules.required]"
                        v-model="model.entity_type"
                      ></v-select>
                    </v-flex>
                    <br />
                    <v-flex xs12 align-end>
                      <v-btn
                        @click="addConstraint"
                        :loading="loading"
                        color="secondary"
                        >{{ $t("drivers.createConstraint.createConstraint") }}</v-btn
                      >
                    </v-flex>
                  </v-form>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-tab-item>
    </v-tabs>
  </v-app>
</template>

<script>
import axios from "axios";
import ChooseTime from "@/components/monaco/input/ChooseTime";
import ChooseDate from "@/components/monaco/input/ChooseDate";
import VueTagsInput from "@johmun/vue-tags-input";

export default {
  name: "addConstraint",
  title() {
    return this.$t("drivers.createConstraint.title");
  },
  components: {
    ChooseDate,
    VueTagsInput,
    ChooseTime,
  },
  created() {
    // console.log(this.$route.params.id);
  },
  data: () => ({
    active: 0,
    loading: false,
    error: false,
    model: {
      constraint_name: "",
      Abbreviation: "",
      customer_app_message: "",
      driver_on_off: false,
      customer_on_off: false,
      dashboard_on_off: false,
      strike_through: false,
      entity_type: "",
    },

    form: false,
  }),

  computed: {
    rules() {
      return {
        required: (v) => !!v || this.$t("common.required"),
      };
    },
  },

  methods: {
    addConstraint() {
      if (this.$refs.form.validate()) {
        const formData = new FormData();

        this.loading = true;
        formData.append("constraint_name", this.model.constraint_name);
        formData.append("Abbreviation", this.model.Abbreviation);
        formData.append(
          "customer_app_message",
          this.model.customer_app_message
        );
        formData.append("driver_on_off", this.model.driver_on_off);
        formData.append("customer_on_off", this.model.customer_on_off);
        formData.append("dashboard_on_off", this.model.dashboard_on_off);
        formData.append("strike_through", this.model.strike_through);
        formData.append("entity_type", this.model.entity_type);
        this.axios
          .post(this.api.ACTIONS.CONSTRAINTS, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            provider: "users",
          })
          .then(() => {
            window.getApp.$emit("SHOW_TOAST", this.$t("drivers.createConstraint.constraintAdded"), "green");
            this.$router.push(`/constraints`);
          })
          .catch((err) => {
            this.error = true;
            let response = err.response;
            if (response) {
              window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
            } else {
              window.getApp.$emit("SHOW_TOAST", this.$t("drivers.createConstraint.checkYourInfo"), "red");

            }
          })
          .then(() => (this.loading = false));
      }
    },
  },
};
</script>
